<template>
  <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" @update="onUpdateJsonData" :titoloEvento="titoloEvento">
    <template slot="tab-content-event">
      <monitoraggio-ecg-edit-component :jsonData="jsonData" @update="onUpdateJsonData"></monitoraggio-ecg-edit-component>
    </template>
  </eventi-edit-component>
</template>
<script>
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixins from "../../../../../utility/UtilityMixin";
import MonitoraggioEcgEditComponent from "./MonitoraggioEcgEditComponent.vue";
export default {
  mixins: [UtilityMixins],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  components: { MonitoraggioEcgEditComponent, EventiEditComponent },
  data() {
    return {
      linkback: null,
      titoloEvento: "Monitoraggio ECG",
      pathResource: "/cardiomonitoraggiecg",
      pathRestValidation: "/validation",
      id: "-1",
      isFirmato: false,
      childKey: 0,
      tabIndex: 0,
      showModalLoading: false,
      jsonData: {
        dataEvento: null,
        codicePrescrizione: null,
        esito: null,
        conduzionesa: null,
        conduzioneav: null,
        conduzioneinterv: null,
        classelown: null,
      },
    };
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    this.jsonData.dataEvento = new Date().getTime();
  },
  methods: {
    onFirmaUpdate() {
      let me = this;
      me.loadData();
    },
    onUpdateFile() {
      let me = this;
      me.childKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
  },
};
</script>
<style scoped>
.ft-space {
  margin-top: 10px;
}
</style>
